import React, { Component } from 'react';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import {
  Edit,
  TextInput,
  ReferenceInput,
  LongTextInput,
  SelectInput,
  TabbedForm,
  FormTab,
  ImageInput,
  ImageField,
  DateInput,
  required,
  REDUX_FORM_NAME,
} from 'react-admin';
import { formValueSelector } from 'redux-form';
import { withStyles } from '@material-ui/core/styles';
import UploadToolbar from 'components/UploadToolbar';
import Cover from './Cover';
import Title from './Title';
import PictureNote from 'components/PictureNote';

const styles = {
  root: {
    marginTop: '24px',
  },
};

const customValidation = values => {
  const errors = {};
  if (values.contact_mobile && !values.contact_mobile.startsWith('+')) {
    errors.contact_mobile = ['Mobile should start with +'];
  }
  if (values.started_at > values.ended_at) {
    errors.ended_at = ['Ended Date must be greater than Started Date'];
  }
  return errors;
};

class EditForm extends Component {
  handleChangeCarBrand = (e, value) => {
    this.setState({ carBrandID: value });
  };

  state = {
    carBrandID: this.props.carBrandID,
  };

  render() {
    const { classes, carBrandID, dispatch, ...props } = this.props;
    return (
      <Edit title={<Title />} {...props}>
        <TabbedForm validate={customValidation} toolbar={<UploadToolbar source={['cover_url']} />}>
          <FormTab label="General">
            <ReferenceInput
              label="Car Brand"
              source="car_brand_id"
              reference="brands"
              perPage={-1}
              onChange={this.handleChangeCarBrand}
              validate={required()}
            >
              <SelectInput optionText="name" />
            </ReferenceInput>
            {carBrandID && (
              <ReferenceInput
                label="Car Model"
                source="car_model_id"
                reference="models"
                emptyValue={0}
                filter={{ car_brand_id: carBrandID }}
                perPage={-1}
                allowEmpty={true}
              >
                <SelectInput optionText="name" />
              </ReferenceInput>
            )}
            <Cover />
            <ImageInput source="qcover_url" label="Cover Image" accept="image/jpeg,image/png">
              <ImageField source="src" title="title" />
            </ImageInput>
            <PictureNote width="400" height="600" />
            <TextInput source="title" fullWidth={true} validate={required()} />
            <LongTextInput source="description" />
          </FormTab>
          <FormTab label="Extra Info">
            <DateInput source="started_at" validate={required()} label="Start Date" />
            <DateInput source="ended_at" validate={required()} label="End Date" />
            <TextInput source="contact_mobile" validate={required()} />
            <TextInput source="contact_email" type="email" validate={required()} />
          </FormTab>
        </TabbedForm>
      </Edit>
    );
  }
}

const formSelector = formValueSelector(REDUX_FORM_NAME);
const mapStateToProps = state => {
  return {
    carBrandID: formSelector(state, 'car_brand_id'),
  };
};

export default compose(
  withStyles(styles),
  connect(mapStateToProps),
)(EditForm);



// WEBPACK FOOTER //
// ./src/containers/Promotion/EditForm.js